import { StreamStatsType, } from '../../../common/interfaces';
export default class StatsMapperHelper {
    static mapStatsStream(stream) {
        return stream.map((item) => {
            return {
                ...item,
                stats: StatsMapperHelper.mapStatsItem(item.stats),
            };
        });
    }
    static mapStatsItem(item) {
        return {
            timestamp: item.timestamp,
            audio: StatsMapperHelper.mapAudioStats(item.audio),
            video: StatsMapperHelper.mapVideoStats(item.video),
        };
    }
    static mapAudioStats(stats) {
        if (!stats)
            return null;
        const streamType = stats.hasOwnProperty('bytesSent')
            ? StreamStatsType.Publisher
            : StreamStatsType.Subscriber;
        return {
            ...stats,
            streamType: streamType,
            packetsLost: stats.packetsLost,
            packetsTransmitted: stats.packetsReceived || stats.packetsSent,
            bytesTransmitted: stats.bytesReceived || stats.bytesSent,
        };
    }
    static mapVideoStats(stats) {
        if (!stats)
            return null;
        return {
            ...StatsMapperHelper.mapAudioStats(stats),
            frameRate: stats.frameRate,
        };
    }
}
